import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "phone"
const PhoneIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 17.216c0 .23-.043.53-.128.901-.085.37-.175.663-.268.876-.18.426-.7.878-1.56 1.355-.801.435-1.594.652-2.378.652-.23 0-.454-.015-.671-.045a5.541 5.541 0 0 1-.735-.16 10.475 10.475 0 0 1-.607-.185 49.99 49.99 0 0 1-.71-.262c-.34-.128-.55-.204-.626-.23a11.578 11.578 0 0 1-2.238-1.061c-1.09-.673-2.217-1.592-3.38-2.755-1.164-1.163-2.083-2.29-2.756-3.381a11.579 11.579 0 0 1-1.06-2.238 27.25 27.25 0 0 0-.231-.626c-.128-.341-.215-.578-.262-.71a10.424 10.424 0 0 1-.185-.607 5.525 5.525 0 0 1-.16-.735A4.932 4.932 0 0 1 3 7.334c0-.784.217-1.577.652-2.378.477-.86.929-1.38 1.355-1.56.213-.093.505-.183.876-.268A4.22 4.22 0 0 1 6.784 3c.12 0 .209.013.269.038.153.051.379.375.677.972.094.162.222.392.384.69.162.299.31.57.447.812.136.243.269.471.396.684.026.034.1.14.224.32.124.179.215.33.275.453.06.124.09.245.09.365 0 .17-.122.383-.365.639s-.507.49-.793.703c-.285.213-.55.44-.792.678-.243.238-.364.434-.364.588 0 .076.02.172.063.287.043.116.08.203.11.263.029.06.089.161.178.306.09.145.139.226.147.243.648 1.168 1.39 2.17 2.225 3.005.835.835 1.836 1.576 3.004 2.224.017.008.098.057.243.147s.247.15.306.179c.06.03.148.066.263.108.115.043.21.064.287.064.154 0 .35-.121.588-.364.239-.243.465-.507.678-.793.213-.285.447-.55.703-.792.256-.243.469-.365.64-.365.118 0 .24.03.363.09.124.06.275.151.454.275.18.123.286.198.32.224.213.128.441.26.684.396.243.136.513.285.812.447.298.162.528.29.69.384.597.298.92.524.972.677.025.06.038.15.038.269Z"
      />
    </svg>
  )
}
export default PhoneIcon
